import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)


export default new Vuex.Store({

    state: {
	    api: 'https://api.cotia.llie.ge/api/',
      obras: {}
    },
    actions: {


    },
    mutations: {
      dadosMedicoes(state, obras){
        state.obras = obras.data
      }
    }

  })



// WEBPACK FOOTER //
// ./src/vuex/store.js